import { MutationHookOptions, gql } from '@apollo/client';

import { edeApplicationQuery } from 'routes/marketplace-ede/queries/ede/getEdeApplication';
import { useEdeMutation, useEdeQueryName } from 'routes/marketplace-ede/context/edeQueryProvider';

const queryType = 'SUBMIT_APPLICATION';

const useSubmitEdeAppMutation = (options: MutationHookOptions = {}) => {
  const queryName = useEdeQueryName(queryType);

  const SUBMIT_EDE_APP_MUTATION = gql`
    mutation SubmitEdeApplication($appID: ID!, $payload: SubmitApplicationInput!) {
      ${queryName} (appID: $appID, payload: $payload) {
        ${edeApplicationQuery}
      }
    }
  `;

  return useEdeMutation(SUBMIT_EDE_APP_MUTATION, options);
};

export default useSubmitEdeAppMutation;
